// 血压设备
const Device = r => require.ensure([], () => r(require('./')), 'Device')
// 授权加载过渡页
const DeviceAuthorization = r => require.ensure([], () => r(require('./authorization')), 'Device')
// 首页
const DeviceHome = r => require.ensure([], () => r(require('./home')), 'Device')
// 单次测量结果
const DeviceResult = r => require.ensure([], () => r(require('./result')), 'Device')
// 测量记录
const DeviceRecord = r => require.ensure([], () => r(require('./record')), 'Device')
// 绑定设备（与解绑成功）
const DeviceBinding = r => require.ensure([], () => r(require('./binding')), 'Device')
// 删除设备
const DeviceDelete = r => require.ensure([], () => r(require('./delete')), 'Device')

export default {
  path: '/device',
  component: Device,
  name: 'device',
  meta: { title: '健康数据' },
  redirect: '/device/home',
  children: [
    {
      path: 'authorization',
      name: 'DeviceAuthorization',
      meta: { title: '加载中...' },
      component: DeviceAuthorization
    },
    {
      path: 'home',
      name: 'DeviceHome',
      meta: { title: '健康数据' },
      component: DeviceHome
    },
    {
      path: 'result',
      name: 'DeviceResult',
      meta: { title: '测量结果' },
      component: DeviceResult
    },
    {
      path: 'record',
      name: 'DeviceRecord',
      meta: { title: '健康数据' },
      component: DeviceRecord
    },
    {
      path: 'binding',
      name: 'DeviceBinding',
      meta: { title: '健康数据' },
      component: DeviceBinding
    },
    {
      path: 'delete/:id',
      name: 'DeviceDelete',
      meta: { title: '健康数据' },
      component: DeviceDelete
    }
  ]
}


// WEBPACK FOOTER //
// ./src/views/device/router.js